import { ROUTE_NAME } from "@/constants/routes-name";
import { lazyWithRetry } from "@/utils/lazy-with-retry";
// import { RoutePermissionGuard } from "./RoutingGuards/route-permission-guard";

const PlanOverview = lazyWithRetry(() => import("../pages/Billing/Plan/PlanOverview"));
const PlanCompare = lazyWithRetry(() => import("../pages/Billing/Plan/PlanCompare"));

export const BILLING_ROUTE = {
  id: ROUTE_NAME.BILLING,
  path: ROUTE_NAME.BILLING,
  children: [
    {
      path: ROUTE_NAME.PLAN,
      children: [
        {
          id: ROUTE_NAME.PLAN,
          Component: () => (
            // <RoutePermissionGuard routeName={ROUTE_NAME.PLAN}>
              <PlanOverview />
            // </RoutePermissionGuard>
          ),
          index: true,
        },
        {
          id: ROUTE_NAME.PLAN_COMPARE,
          Component : PlanCompare,
          index: true,
          path: ROUTE_NAME.PLAN_COMPARE,
        }
      ]
    }
  ]
}